import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetopanvelcabs() {



const cardData = {
  keyword: " Pune to Panvel Cabs ",

"headingDescription": "SRS Cab Service offers Pune to Panvel Cabs, providing a comfortable, safe, and efficient travel solution for families, professionals, and travelers commuting between Pune and Panvel. Our well-maintained vehicles, skilled drivers, and timely pickups ensure a smooth and hassle-free journey. Ideal for business trips, city transfers, and weekend travel, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a convenient and reliable travel experience.",
"topPlaces": [
  {
    "title": "Karnala Bird Sanctuary",
    "description": "Karnala Bird Sanctuary is a popular nature destination near Panvel known for its rich birdlife and greenery. Travelers using SRS Cab Service from Pune often visit for trekking and bird watching."
  },
  {
    "title": "Karnala Fort",
    "description": "Karnala Fort is a historic hill fort located within the sanctuary. Visitors using SRS Cab Service often trek to the top to enjoy panoramic views and explore its history."
  },
  {
    "title": "Ballaleshwar Pali Temple",
    "description": "Ballaleshwar Temple in Pali is one of the Ashtavinayak temples dedicated to Lord Ganesha. Travelers using SRS Cab Service often include this sacred site in their itinerary."
  },
  {
    "title": "Gadeshwar Dam",
    "description": "Gadeshwar Dam is a peaceful spot surrounded by hills and greenery. Visitors using SRS Cab Service often stop here for relaxation and scenic views."
  },
  {
    "title": "Adai Waterfall",
    "description": "Adai Waterfall is a seasonal waterfall near Panvel, popular during monsoon. Travelers using SRS Cab Service often visit to enjoy nature and photography."
  },
  {
    "title": "Pandavkada Falls",
    "description": "Pandavkada Falls is a famous waterfall near Panvel known for its beauty and height. Visitors using SRS Cab Service often include this spot in their monsoon travel plans."
  },
  {
    "title": "Belapur Fort",
    "description": "Belapur Fort is a historic structure near Panvel with scenic surroundings. Travelers using SRS Cab Service often explore this site for history and views."
  },
  {
    "title": "Central Park Kharghar",
    "description": "Central Park in Kharghar is a large urban park ideal for walking and relaxation. Visitors using SRS Cab Service often visit this spot for leisure time."
  },
  {
    "title": "Iskcon Kharghar",
    "description": "ISKCON Temple Kharghar is a peaceful spiritual destination dedicated to Lord Krishna. Travelers using SRS Cab Service often stop here for prayer and meditation."
  },
  {
    "title": "Little Chowk Market",
    "description": "Little Chowk Market is a popular local shopping and food area in Panvel. Visitors using SRS Cab Service often explore this market for local cuisine and shopping."
  }
],



services: [
{
name: "Pune to Panvel Cabs",
description: "Pune to Panvel cabs offer reliable intercity travel for business and leisure trips. Customers can book cabs for comfortable journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily from Pune to Panvel with cab services."
},
{
name: "Pune to Panvel Taxi Booking",
description: "Pune to Panvel taxi booking provides quick and easy reservation options. Customers can book taxis online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily from Pune."
},
{
name: "Pune to Panvel Car Rental",
description: "Pune to Panvel car rental offers flexible travel options for short and long trips. Customers can rent cars for business and family travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Rent cars easily from Pune."
},
{
name: "Pune to Panvel Taxi Rates",
description: "Pune to Panvel taxi rates provide clear pricing details for travelers. Customers can compare rates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose taxi services with transparent rates."
},
{
name: "Pune to Panvel Cab Charges",
description: "Pune to Panvel cab charges offer detailed pricing for travel planning. Customers can check charges before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent charges."
},
{
name: "Pune to Panvel Cab Pricing",
description: "Pune to Panvel cab pricing provides a complete cost breakdown for trips. Customers can compare pricing before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with transparent pricing."
},
{
name: "Pune to Panvel Private Car Hire",
description: "Pune to Panvel private car hire offers personalized travel for families and corporate trips. Customers can hire vehicles for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with private car hire services."
},
{
name: "Pune to Panvel Cab Cost",
description: "Pune to Panvel cab cost provides estimated pricing for travelers. Customers can check trip cost before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab cost services."
},
{
name: "Pune to Panvel Taxi Service",
description: "Pune to Panvel taxi service offers dependable transportation for intercity travel. Customers can book taxis for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Panvel Travel Cabs",
description: "Pune to Panvel travel cabs provide convenient options for daily and occasional trips. Customers can book cabs for comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with travel cab services."
},
{
name: "Pune to Panvel Cab Booking",
description: "Pune to Panvel cab booking offers quick reservation options for travelers. Customers can book cabs online or via mobile apps. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily from Pune."
},
{
name: "Pune to Panvel Cab Fare",
description: "Pune to Panvel cab fare provides detailed pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab fare services."
},
{
name: "Pune to Panvel Cab One Way",
description: "Pune to Panvel cab one way offers economical travel without return charges. Customers can book direct rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one-way cab services."
},
{
name: "Pune to Panvel Cab Price",
description: "Pune to Panvel cab price provides clear pricing information for travelers. Customers can check price estimates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent pricing."
},
{
name: "Pune to Panvel Distance Taxi",
description: "Pune to Panvel distance taxi provides travel solutions based on route distance. Customers can book taxis for accurate fare calculation. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with distance-based taxi services."
},
{
name: "Pune to Panvel Taxi",
description: "Pune to Panvel taxi offers convenient travel for short intercity trips. Customers can book taxis for business and leisure travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Panvel Taxi Fare",
description: "Pune to Panvel taxi fare provides estimated pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with taxi fare services."
},
{
name: "Pune to Panvel Tempo Traveller on Rent",
description: "Pune to Panvel tempo traveller on rent offers group travel solutions. Customers can book spacious vehicles for family and corporate trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "Pune to Navi Mumbai Cab",
description: "Pune to Navi Mumbai cab provides reliable transportation for city connections. Customers can book cabs for business and airport travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Navi Mumbai Airport Cab",
description: "Pune to Navi Mumbai airport cab offers convenient airport transfer services. Customers can book cabs for timely travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily to Navi Mumbai Airport."
},
{
name: "Pune to Navi Mumbai Airport Taxi Service",
description: "Pune to Navi Mumbai airport taxi service provides dependable travel for airport transfers. Customers can book taxis for timely journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport taxi services."
},
{
name: "Pune to Panvel Cab Service",
description: "Pune to Panvel cab service offers reliable transportation for intercity travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Panvel Taxi Service",
description: "Pune to Panvel taxi service provides convenient travel options for daily and business trips. Customers can book taxis for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
}
],

tableData: [
["Pune to Panvel Cabs","Pune to Panvel Taxi Booking"],
["Pune to Panvel Car Rental","Pune to Panvel Taxi Rates"],
["Pune to Panvel Cab Charges","Pune to Panvel Cab Pricing"],
["Pune to Panvel Private Car Hire","Pune to Panvel Cab Cost"],
["Pune to Panvel Taxi Service","Pune to Panvel Travel Cabs"],
["Pune to Panvel Cab Booking","Pune to Panvel Cab Fare"],
["Pune to Panvel Cab One Way","Pune to Panvel Cab Price"],
["Pune to Panvel Distance Taxi","Pune to Panvel Taxi"],
["Pune to Panvel Taxi Fare","Pune to Panvel Tempo Traveller on Rent"],
["Pune to Navi Mumbai Cab","Pune to Navi Mumbai Airport Cab"],
["Pune to Navi Mumbai Airport Taxi Service","Pune to Panvel Cab Service"],
["Pune to Panvel Taxi Service","Pune to Panvel Cabs"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Highway Route Drivers",
    WhyChoosedescription: "SRS Cab Service provides skilled drivers familiar with Pune to Panvel routes via Mumbai-Pune Expressway, ensuring safe driving and smooth travel."
  },
  {
    WhyChooseheading: "Affordable Pune to Panvel Cab Pricing",
    WhyChoosedescription: "We offer budget-friendly Pune to Panvel cab services with transparent pricing. Customers receive complete fare details including tolls and driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Pune to Panvel cab bookings, making it convenient for business travel, airport transfers, and daily commuting."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned vehicles to ensure a comfortable journey from Pune to Panvel."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "We provide one-way cab service, round-trip bookings, and customized travel plans for Pune to Panvel journeys."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for individuals, families, and group travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We offer convenient pickup from homes, hotels, offices, and Pune Airport across all major areas including Hinjewadi, Wakad, Baner, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Panvel cab bookings due to punctual drivers, reliable vehicles, and professional service."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Panvel cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Pune to Panvel." },
  { question: "How far is Panvel from Pune?", answer: "The distance between Pune and Panvel is approximately 120 km and the journey takes around 2.5 to 3 hours." },
  { question: "Is Pune to Panvel cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible travel planning." },
  { question: "Which vehicles are available for Pune to Panvel travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Pune to Panvel?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Do you provide pickup from Pune home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the cab online?", answer: "Yes, you can easily book Pune to Panvel cab service online or via phone." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." },
  { question: "Do you provide round trip packages?", answer: "Yes, we offer affordable round-trip cab packages for Pune to Panvel travel." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Patil",
    feedback:
      "Booked SRS Cab Service for Pune to Panvel trip. Smooth journey and driver was very professional.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Deshmukh",
    feedback:
      "Reliable Pune to Panvel cab service. Clean car and comfortable ride.",
    rating: 5
  }
];




























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Panvel Cab | SRS Cab",
  "description": "Book Pune to Panvel cabs with SRS Cab. One-way, round trips, and private car hire available. Travel comfortably with Innova, Swift Dzire, Sedan, Kia Carens, or Tempo Traveller. Affordable taxi services with 24x7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2150"
  }
};





  return (
    <div>
      <Helmet>
  <title>Pune to Panvel Cab | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="SRS Cab provides Pune to Panvel cab services including one-way, round trips, and private car hire. Travel comfortably with Innova, Dzire, Sedan, Kia Carens, and Tempo Traveller. Book online 24x7." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/44.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetopanvelcabs;